import vm from '../main'

import { httpClient as http } from '../services'

const internals = {}

internals.addtripRoute = function (tripRoute) {
    tripRoute = (({
        _id,
        name,
        approxDistance,
        approxTime,
        status,
        startSite,
        endSite,
        routeMarkers,
        region,
        reportAssessment
    }) => {
        return {
            _id,
            name,
            approxDistance,
            approxTime,
            status,
            startSite,
            endSite,
            routeMarkers,
            region,
            reportAssessment
        }
    })(tripRoute)

    return vm.$tripCreateRouteDataRepository
        .create(tripRoute)
        .then(result => {
            tripRoute = result.data
            return tripRoute
        })
        .catch(error => {
            console.error('tripRouteService.createtripRoute-error:\n', error)
            throw error
        })
}

internals.updatetripRoute = function (tripRoute) {
    tripRoute = Object.assign({}, tripRoute)
    tripRoute = (({
        _id,
        name,
        approxDistance,
        approxTime,
        status,
        startSite,
        endSite,
        routeMarkers,
        region,
        reportAssessment
    }) => {
        return {
            _id,
            name,
            approxDistance,
            approxTime,
            status,
            startSite,
            endSite,
            routeMarkers,
            region,
            reportAssessment
        }
    })(tripRoute)
    return vm.$triprouteDataRepository
        .update(tripRoute._id, tripRoute)
        .then(result => {
            tripRoute = result.data
            return tripRoute
        })
        .catch(error => {
            console.error('tripRouteUpdate.update-error:\n', error)
            throw error
        })
}

internals.updatesubTripRouteDetails = subTripDetails => {
    return http
        .put(`/v1/update/group/trip/subtrip?groupTripId=${subTripDetails._id}`, {
            subtrips: subTripDetails.subtrips
        })
        .then(response => {
            return response
        })
        .catch(error => {
            console.error('authService.login-error:\n', error)
            throw error
        })
}

internals.updatetripRouteDetails = trip => {

    return http
        .put(`v1/updateGroupTrip?groupTripId=${trip._id}`, {

            driverId: trip.driverId,
            status: trip.status,
            scheduleTime: trip.scheduleTime,
            deviceId: trip.deviceId,
            journeyManager: trip.journeyManager,
            regionManager: trip.regionManager,
            scheduleDate: trip.scheduleDate,
            geographical_area: trip.geographical_area,
            vehicleId: trip.vehicleId,
            // _id: trip._id


        })
        .then(result => {
            trip = result.data
            return result
        })
        .catch(error => {
            console.error('update group Trip-error:\n', error)
            throw error
        })
}



export default internals


// WEBPACK FOOTER //
// ./src/services/tripRoute.service.js